import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import BaseLayout from '../../components/BaseLayout';
import BannerSlider from '../../components/BannerSlider';
import SearchBox from '../../components/Search';
import { formatToCurrency, priceDecimal } from '../../utils/utilities';
import { statusSnapReceipt } from '../../utils/constant';
import { toast } from 'react-toastify';
import * as PageRoutes from './../../utils/route_pages';
import './style.scss';

const ReceiptReviewDetail = (props) => {
  const {
    getDataById,
    dataReceipt,
    postReceipt,
    setting,
    getCategory,
    getProduct,
    categories,
    products,
    getRetrieveSetting,
  } = props;

  const {
    product,
    category,
    images,
    status,
    transaction_date,
    amount,
    code,
    created,
    total_point,
  } = dataReceipt;

  const { id } = useParams();
  const [message, setMessage] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFrom, setSelectedFrom] = useState('');
  const [isMultipleSelected, setIsMultipleSelected] = useState(false);
  const [displaySelectedProduct, setDisplaySelectedProduct] = useState(null);
  const [displaySelectedCategory, setDisplaySelectedCategory] = useState(null);
  const [listData, setListData] = useState(null);
  const [payload, setPayload] = useState(null);
  const [displayAmount, setDisplayAmount] = useState('');
  const [dataImg, setDataImg] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const payloadFromPreviousData = location?.state?.payload;

  const handleFocus = (e) => {
    const val = e.target.value;
    e.target.value = '';
    e.target.value = val;

    if (setting?.minimum_transaction) {
      setMessage(
        `The receipt amount should not be lower than the minimum transaction of ${priceDecimal(
          setting?.minimum_transaction
        )} IDR.`
      );
    }
  };

  const handleSelectCategory = () => {
    setIsOpen(true);
    setSelectedFrom('category');
    setIsMultipleSelected(false);
    setListData(categories);
  };

  const handleSelectProduct = () => {
    if (!payload || !payload.category_id) {
      toast.error('Please select the category', {
        position: toast.POSITION.BOTTOM_LEFT,
      });

      return;
    }

    setIsOpen(true);
    setSelectedFrom('product');
    setIsMultipleSelected(true);
    setListData(products);
  };

  useEffect(() => {
    if (id) {
      getDataById(id);
    }
  }, [id]);

  useEffect(() => {
    if (payloadFromPreviousData) {
      setDataImg(payloadFromPreviousData);
    }
  }, []);

  useEffect(() => {
    getCategory();
    getRetrieveSetting();
  }, []);

  useEffect(() => {
    if (id && images) {
      const imgs = images.map((item) => {
        return {
          images: {
            img: {
              display: item.image,
            },
          },
        };
      });
      setDataImg(imgs);
    }
  }, [images]);

  const ReceiptData = () => {
    const getStatus = statusSnapReceipt.find((item) => item.key === status);

    return (
      <div>
        <div className="d-flex align-items-center justify-content-between fs-18">
          <div>
            <h4>Receipt #{code}</h4>
          </div>
          <div>
            <Button
              style={{
                background: getStatus?.bg,
                color: getStatus?.color,
                textTransform: 'uppercase',
              }}
              className="border-0 fs-12"
              disabled
            >
              {getStatus?.name}
            </Button>
          </div>
        </div>
        <div className="container mt-3">
          <h5 className="text-title-main-color">Details</h5>
          <Form>
            <Form.Group as={Row} controlId="formUploadDate">
              <Form.Label column sm={4} className="fs-12 text-black-400">
                Receipt Upload Date:
              </Form.Label>
              <Col sm={8} className="fs-14 text-gray-400">
                <p>{moment(created).format('DD MMM YYYY')}</p>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formTransactionDate">
              <Form.Label column sm={4} className="fs-12 text-black-400">
                Transaction Date:
              </Form.Label>
              <Col sm={8} className="fs-14 text-gray-400">
                <p>{moment(transaction_date).format('DD MMM YYYY')}</p>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formCategory">
              <Form.Label column sm={4} className="fs-12 text-black-400">
                Category:
              </Form.Label>
              <Col sm={8} className="fs-14 text-gray-400">
                <p>{category}</p>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formProductItem">
              <Form.Label column sm={4} className="fs-12 text-black-400">
                Product / Item:
              </Form.Label>
              <Col sm={8} className="fs-14 text-gray-400">
                <p>{product}</p>
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formAmount">
              <Form.Label column sm={4} className="fs-12 text-black-400">
                Total Receipt Amount:
              </Form.Label>
              <Col sm={8} className="fs-14 text-gray-400">
                <p>IDR {priceDecimal(amount)}</p>
              </Col>
            </Form.Group>

            {status === 'rejected' ? (
              <Form.Group as={Row} controlId="formRewards">
                <Form.Label column sm={4} className="fs-12 text-black-400">
                  Reviewer Note :
                </Form.Label>
                <Col sm={8} className="fs-14 text-gray-400">
                  <p>{dataReceipt?.reason}</p>
                </Col>
              </Form.Group>
            ) : (
              <Form.Group as={Row} controlId="formRewards">
                <Form.Label column sm={4} className="fs-12 text-black-400">
                  Rewards:
                </Form.Label>
                <Col sm={8} className="fs-14">
                  {status === 'on_progress' ? (
                    <p className="text-gray-400">
                      (Reward will be received once approved)
                    </p>
                  ) : (
                    <p className="text-gray-400">+{total_point} Pts</p>
                  )}
                </Col>
              </Form.Group>
            )}
          </Form>
        </div>
      </div>
    );
  };

  const handleSelectedItem = (selected) => {
    const { type, selectedItems } = selected;
    const dataListSelect = type === 'category' ? categories : products;

    const data = dataListSelect
      .filter((item) => selectedItems.includes(item.id))
      .map((item) => item.name);

    if (type === 'category') {
      setPayload({
        ...payload,
        category_id: selectedItems,
      });
      setDisplaySelectedCategory(data.join(', '));
      setDisplaySelectedProduct('');
      getProduct(selectedItems[0]);
    } else {
      setPayload({
        ...payload,
        product_ids: selectedItems,
      });
      setDisplaySelectedProduct(data.join(', '));
    }
    setIsOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    // Add all properties from payload to formData
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    for (const img of dataImg) {
      formData.append('images', img.images.img.file);
    }

    setIsLoading(true);

    postReceipt(formData)
      .then((response) => {
        if (response.status === 200) {
          navigate(`${PageRoutes.snapReceipt}/success-submitted`);
          setIsLoading(false);
        }

        if (response.status === 400) {
          Object.keys(response.message).forEach((key) => {
            response.message[key].forEach((message) => {
              toast.error(`${key}: ${message}`, {
                position: toast.POSITION.BOTTOM_LEFT,
              });
            });
          });
          setIsLoading(false);
        }
      })
      .catch(() => {
        toast.error('Kesalahan pada sistem', {
          position: toast.POSITION.BOTTOM_LEFT,
        });
        setIsLoading(false);
      });
  };

  const [formattedDate, setFormattedDate] = useState('');
  const [inputType, setInputType] = useState('date');

  const handleDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    const formatted = selectedDate.toLocaleDateString('en-GB', options);

    setFormattedDate(formatted);
    setPayload({
      ...payload,
      transaction_date: e.target.value,
    });
    setInputType('text'); // Change input type to text to display formatted date
  };

  const handleFocusDate = () => {
    setInputType('date'); // Change back to date type when the user focuses on the input
  };

  const handleAmountChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatToCurrency(inputValue);
    setDisplayAmount(formattedValue);
    setPayload({
      ...payload,
      amount: formattedValue.replace(/[^\d]/g, ''),
    });
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <div>
      {isOpen ? (
        <SearchBox
          onClose={() => setIsOpen(false)}
          isMultipleSelected={isMultipleSelected}
          type={selectedFrom}
          datas={listData}
          selectedItem={(selected) => handleSelectedItem(selected)}
        />
      ) : (
        <BaseLayout
          show_menu={false}
          bottomNavIndex={1}
          header={
            <BannerSlider
              data={dataImg}
              toPath={-1}
              isVideo={false}
              isDisplay={false}
            />
          }
          isCustom={true}
        >
          <div className="container wrapper-scroll mt-5">
            {id ? (
              <ReceiptData />
            ) : (
              <>
                <div className="fs-14 text-black-400">RECEIPT INFORMATION</div>
                <div className="fs-12">
                  <Form onSubmit={handleSubmit}>
                    <Form.Group as={Row} controlId="formAmount">
                      <Form.Label column sm={2}>
                        Amount :
                      </Form.Label>
                      <Col sm={10}>
                        <InputGroup>
                          <InputGroup.Text className="fs-14">
                            IDR
                          </InputGroup.Text>
                          <Form.Control
                            className="fs-14"
                            type="text"
                            placeholder="Enter amount"
                            onFocus={handleFocus}
                            value={displayAmount}
                            required
                            onBlur={() => setMessage(null)}
                            onChange={handleAmountChange}
                          />
                        </InputGroup>
                        {message && (
                          <div className="text-danger">{message}</div>
                        )}
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formTransactionDate">
                      <Form.Label column sm={2}>
                        Transaction Date :
                      </Form.Label>
                      <Col sm={10}>
                        <Form.Control
                          className="fs-14"
                          type={inputType}
                          placeholder="DD/MM/YYYY"
                          defaultValue={payload?.transaction_date}
                          required
                          value={formattedDate}
                          onChange={handleDateChange}
                          onFocus={handleFocusDate}
                          min={'1970-01-01'}
                          max={today}
                        />
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formCategory">
                      <Form.Label column sm={2}>
                        Category :
                      </Form.Label>
                      <Col sm={10}>
                        <Form.Control
                          className="fs-14"
                          as="select"
                          required
                          onClick={handleSelectCategory}
                        >
                          {displaySelectedCategory ? (
                            <option>{displaySelectedCategory}</option>
                          ) : (
                            <option>Select a category</option>
                          )}
                        </Form.Control>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} controlId="formProductItem">
                      <Form.Label column sm={2}>
                        Product Item :
                      </Form.Label>
                      <Col sm={10}>
                        <Form.Control
                          className="fs-14"
                          as="select"
                          required
                          onClick={handleSelectProduct}
                        >
                          {displaySelectedProduct ? (
                            <option>{displaySelectedProduct}</option>
                          ) : (
                            <option>Select a product / item</option>
                          )}
                        </Form.Control>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row}>
                      <Col sm={{ span: 10, offset: 2 }}>
                        {setting?.note ? (
                          <div className="mt-3">Note :</div>
                        ) : (
                          ''
                        )}
                        <Form.Text className="text-muted mt-3 fs-12">
                          {setting?.note ? <div>{setting?.note}</div> : ''}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="my-5">
                      <Col>
                        <Button
                          variant="outline"
                          className="btn btn-outline-danger border-0 w-100 fs-14"
                          onClick={() => navigate(`${PageRoutes.snapReceipt}`)}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          className="fs-14"
                          type="submit"
                          variant="danger"
                          disabled={isLoading}
                        >
                          Submit
                        </Button>
                      </Col>
                    </Form.Group>
                  </Form>
                </div>
              </>
            )}
          </div>
        </BaseLayout>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataReceipt: state.SnapReceiptSM.dataReceipt,
  setting: state.SnapReceiptSM.setting,
  categories: state.SnapReceiptSM.category,
  products: state.SnapReceiptSM.products,
});

const mapDispatchToProps = (dispatch) => ({
  getDataById: dispatch.SnapReceiptSM.getDataById,
  postReceipt: dispatch.SnapReceiptSM.postReceipt,
  getCategory: dispatch.SnapReceiptSM.getCategory,
  getProduct: dispatch.SnapReceiptSM.getProduct,
  getRetrieveSetting: dispatch.SnapReceiptSM.getRetrieveSetting,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReceiptReviewDetail);
